import * as React from "react";
const SvgDeprecatedArgument = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 14 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.2, d: "M5.048 1.408a2.76 2.76 0 0 1 3.904 0l3.64 3.64a2.76 2.76 0 0 1 0 3.904l-3.64 3.64a2.76 2.76 0 0 1-3.904 0l-3.64-3.64a2.76 2.76 0 0 1 0-3.904zM5 9l4-4M5 5l4 4" }));
export {
  SvgDeprecatedArgument as default
};
//# sourceMappingURL=deprecated-argument.js.map
